import { render, staticRenderFns } from "./companyaddorupdate.vue?vue&type=template&id=412a3f50"
import script from "./companyaddorupdate.vue?vue&type=script&lang=js"
export * from "./companyaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports